import namespace  from './namespace';

export const UPDATE_VIEW_PORT_TYPE = namespace + '/UPDATE_VIEW_PORT_TYPE';